import { Path } from 'react-router-dom';
import { httpClient } from './axiosInstance';

export type GlobalSearchLocalResult = {
	key: string;
	uuid?: string | null;
	labelKind: 'link' | 'action';
	label: string;
	action: {
		name: string;
		params?: Record<string, string | number | boolean | null>;
	} | null;
	route?: Path;
	info: string | null;
};

export type GlobalSearchKnowledgeBaseResult = {
	key: string;
	uuid?: string | null;
	labelKind: 'link';
	label: string;
	action: null;
	route: Path;
	context: 'knowledgeBase';
	info: null;
	articleId: number;
	slug: string | null;
};

export type GlobalSearchResponse = {
	uuid?: string | null;
	navigation: GlobalSearchLocalResult[];
	pairs: GlobalSearchLocalResult[];
	timeline?: GlobalSearchLocalResult[];
	knowledgeBase: GlobalSearchKnowledgeBaseResult[];
};

export type GlobalSearchSelectionLogResponse = {
	used: number;
};

export const globalSearchApi = {
	search: (applicationId: number, search: string, uuid?: string | null) =>
		httpClient.get<GlobalSearchResponse>(`global-search/application/${applicationId}`, {
			search,
			...(uuid ? { uuid } : {}),
		}),
	registerSelection: (uuid: string) => httpClient.post<GlobalSearchSelectionLogResponse>(`global-search/${uuid}`),
};
